import { Component, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import FieldWrapper from '../field-wrapper/field-wrapper.vue';
import AbstractField from '@/app/modules/shared/components/forms/inputs/abstract-field/abstract-field';
import BPCGenericApiResponse from '@core/interfaces/bpc-generic-api-response';
import { Observable } from 'rxjs';
import { StripeConnectStatus } from '@shared/interfaces/StripeConnectStatus';
import BPCStripeConnectService from '@accounting/services/bpc-stripe-connect-api.service';

const bpcStripeConnectService = new BPCStripeConnectService();

@Component({
  name: 'bpc-stripe-connect-link',
  components: {
    'bpc-field-wrapper': FieldWrapper,
  },
})
export default class StripeConnectLink extends mixins(AbstractField) {
  //props
  @Prop({ type: String }) readonly textCreation: string;
  @Prop({ type: String }) readonly textUpdate: string;
  @Prop({ type: String }) readonly textDashboard: string;
  @Prop({ type: String }) readonly labelCreation: string;
  @Prop({ type: String }) readonly labelUpdate: string;
  @Prop({ type: String }) readonly labelDashboard: string;

  // COMPUTED
  get isDisabled() {
    return this.loading;
  }
  // DATA
  ButtonStripeConnect: string = 'Loading ...';
  loading: boolean = false;
  labelStripeConnectLink: string = 'Loading ...';

  //LifeCycle Hooks
  async mounted() {
    this.initStripeConnect();
  }

  //METHODS
  async initStripeConnect(): Promise<void> {
    this.loading = true;
    const res = await bpcStripeConnectService.getStripeConnectStatus();
    if (res.created && res.finished) {
      //Account correctly configured
      this.ButtonStripeConnect = this.textDashboard;
      this.labelStripeConnectLink = this.labelDashboard;
    } else if (res.created && res.finished == false) {
      //Account created but not entirely configured
      this.ButtonStripeConnect = this.textUpdate;
      this.labelStripeConnectLink = this.labelUpdate;
    } else if (res.created == false && res.finished == false) {
      //Account not created
      this.ButtonStripeConnect = this.textCreation;
      this.labelStripeConnectLink = this.labelCreation;
    } else {
      //error
    }
    this.loading = false;
  }

  async redirectStripeConnect() {
    if (this.loading == false) {
      bpcStripeConnectService.redirectStripeConnect();
    }
  }

  // WHATCHER
}
